import React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import timesIcon from '@assets/timesIcon.svg';
import { useUserStore } from '@store/use-user-store';

const Background = styled.div`
  background: ${({ theme }) => rgba(theme.primary, 0.5)};
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalInner = styled.div`
  border-radius: 18px;
  background: ${({ theme }) => theme.white};
  position: relative;
  min-width: 40vw;
  max-width: 40vw;
  padding: 50px;
  min-height: 70vh;
  max-height: 80vh;
  overflow: auto;

  @media only screen and (max-width: 1200px) {
    min-height: 80vh;
    max-height: 90vh;
    padding: 8px;
    min-width: 85vw;
    max-width: 90vw;
    position: unset;
  }
`;

const TimesIcon = styled.img`
  cursor: pointer;
  position: absolute;
  right: 8px;
  top: 8px;
`;

const Links: Record<string, string> = {
  hu: 'https://www.knorr-bremse.hu/media/documents/railvehicles/downloads/beleptetes_adatkezelesi_tajekoztato/Belptets_adatkezelsi_tjkoztat_nyilatkozat_nlkuel_HUN.pdf',
  de: 'https://www.knorr-bremse.hu/media/documents/railvehicles/downloads/beleptetes_adatkezelesi_tajekoztato/Belptets_adatkezelsi_tjkoztat_nyilatkozat_nlkueli_de.pdf',
  en: 'https://www.knorr-bremse.hu/media/documents/railvehicles/downloads/beleptetes_adatkezelesi_tajekoztato/Belptets_adatkezelsi_tjkoztat_nyilatkozat_nlkueli_eng.pdf'
};

interface PdfModalProps {
  closeModal: () => void;
}

function PdfModal({ closeModal }: PdfModalProps) {
  const { selectedLang } = useUserStore();
  return (
    <Background>
      <ModalInner>
        <TimesIcon src={timesIcon} alt="times-icon" onClick={closeModal} />
        <iframe
          src={`${Links[selectedLang]}#toolbar=0&navpanes=0&scrollbar=0`}
          height="700"
          width="100%"
        ></iframe>
      </ModalInner>
    </Background>
  );
}

export default PdfModal;
